import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { Notification } from "ui/notification";
import { Box } from "view/layout/box";

import DateRange from "./date-range";

class ReportFilter extends React.PureComponent {
  static get propTypes() {
    return {
      network: PropTypes.object,
      options: PropTypes.array.isRequired,
      start: PropTypes.string,
      end: PropTypes.string,
      onRun: PropTypes.func.isRequired,
      submitted: PropTypes.bool.isRequired,
    };
  }

  constructor() {
    super();

    this.state = {
      selected: null,
      report: {
        device: {},
        network: {},
      },
      errorMessage: "",
    };

    this._onNetworkSelect = this._onNetworkSelect.bind(this);
    this._runReport = this._runReport.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.network !== this.props.network) {
      this._setSelectedNetwork(this.props);
    }
  }

  componentDidMount() {
    this._setSelectedNetwork(this.props);
  }

  _setSelectedNetwork(props) {
    const { network } = props;
    const selectedNetwork = network
      ? { value: network.id, label: network.name }
      : null;

    this.setState({ selected: selectedNetwork });
  }

  _onNetworkSelect(option) {
    this.setState({
      selected: option,
    });
  }

  _runReport() {
    const { onRun } = this.props;
    const { selected } = this.state;
    const selectedValue = selected ? selected.value : null;
    const dates = this.dateRange.get();
    if (!onRun || !selectedValue || !dates || !dates.start || !dates.end) {
      return;
    }
    const start = dates.start.format("YYYY-MM-DD");
    const end = dates.end.format("YYYY-MM-DD");

    onRun(selectedValue, start, end);
  }

  render() {
    const { end, options, submitted, start } = this.props;
    const { errorMessage, selected } = this.state;
    const btnClassNames = classNames("fa fa-refresh", { "fa-spin": submitted });

    return (
      <Box title="Filter">
        <Row>
          <Col xs={12}>
            <Notification error={errorMessage} />
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <Select
              name="network-select"
              onChange={this._onNetworkSelect}
              options={options}
              placeholder="Select network"
              value={selected}
            />
          </Col>
          <Col xs={3}>
            <DateRange
              ref={(c) => {
                this.dateRange = c;
              }}
              start={start}
              end={end}
            />
          </Col>
          <Col xs={1}>
            <Button
              variant="primary"
              onClick={this._runReport}
              disabled={submitted}
            >
              <i className={btnClassNames} /> Run
            </Button>
          </Col>
        </Row>
      </Box>
    );
  }
}

export { ReportFilter };
